export default "__VITE_ASSET__6a456414__"